export const defaultData = {
    companyInfo: {
        document: null,
        vatValue: 20,
        companyId: "e5c06127-3c5d-44b9-8403-74c160fc7f59",
        industry: "IIOT",
        companyType: "Baca Companies",
        fiscalYearStartDate: "2025-12-01",
        fiscalYearEndDate: "2026-12-31",
        country: "Turkey",
        timeZone: "Europe/Istanbul (GMT+03:00)",
        language: "Türkçe",
        status: "Activated",
    },

    contactInfo: {
        cCount: "EU-0.417",
        t1Standard: "24.21",
        t1: "3.77",
        t2: "4.6962",
        t3: "2.434",
        solutions: "upu.machine, upu.product, upu.person",
        contractNo: "BACA0001",
        accountType: "Demo",
        shift: 500,
    },

    contractInfo: {
        user: 1000,
        node: 10000,
        department: 80,
        message: 1230,
        notification: 10000,
        junction: 500,
        externalOperation: 500,
        supplier: 500,
        order: 20,
        operation: 30,
        embeddedServer: 2000,
        stockCardOperation: 50,
        poll: 200,
        task: 3000,
        stockCard: 1000,
        attend: 200,

        ADMIN: 20,
        OPERATOR: 30,
        SHIFT_RESPONSIBLE: 4,
        QUALITY_CONTROL_RESPONSIBLE: 5,
        OPERATION_RESPONSIBLE: 10,
        PURCHASING_RESPONSIBLE: 4,
        PURCHASING_OPERATOR: 4,
        APP_USER: 4,
        WHITE_COLLAR: 10,
        TABLET_USER: 2,

    },
};
